// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   CSS VARIABLES - Design System
   ============================================ */
:root {
  --primary: #F25C24;
  --primary-hover: #D94D1A;
  --secondary: #3E3E3E;
  --background-light: #F3F4F6;
  --surface-light: #FFFFFF;
  --border-light: #E5E7EB;
  --text-primary: #1F2937;
  --text-secondary: #6B7280;
  --text-muted: #9CA3AF;

  /* Info Banner Colors */
  --info-bg: #EFF6FF;
  --info-border: #DBEAFE;
  --info-text: #1E40AF;
  --info-icon: #3B82F6;

  /* Success Colors */
  --success-bg: #F0FDF4;
  --success-border: #BBF7D0;
  --success-text: #166534;

  /* Warning Colors */
  --warning-bg: #FEF3C7;
  --warning-border: #FDE68A;
  --warning-text: #92400E;

  /* Error Colors */
  --error-bg: #FEE2E2;
  --error-border: #FECACA;
  --error-text: #991B1B;

  /* File Type Colors */
  --icon-purple: #A855F7;
  --icon-purple-bg: #F3E8FF;
  --icon-green: #10B981;
  --icon-green-bg: #D1FAE5;
  --icon-red: #EF4444;
  --icon-red-bg: #FEE2E2;
  --icon-blue: #3B82F6;
  --icon-blue-bg: #DBEAFE;
  --icon-gray: #6B7280;
  --icon-gray-bg: #F3F4F6;
}

[data-theme="dark"] {
  --background-light: #18181b;
  --surface-light: #27272a;
  --border-light: #3f3f46;
  --text-primary: #F3F4F6;
  --text-secondary: #D1D5DB;
  --text-muted: #9CA3AF;

  --info-bg: rgba(59, 130, 246, 0.1);
  --info-border: rgba(59, 130, 246, 0.3);
  --info-text: #93C5FD;

  --success-bg: rgba(16, 185, 129, 0.1);
  --success-border: rgba(16, 185, 129, 0.3);
  --success-text: #6EE7B7;

  --warning-bg: rgba(245, 158, 11, 0.1);
  --warning-border: rgba(245, 158, 11, 0.3);
  --warning-text: #FCD34D;

  --error-bg: rgba(239, 68, 68, 0.1);
  --error-border: rgba(239, 68, 68, 0.3);
  --error-text: #FCA5A5;

  --icon-purple-bg: rgba(168, 85, 247, 0.2);
  --icon-green-bg: rgba(16, 185, 129, 0.2);
  --icon-red-bg: rgba(239, 68, 68, 0.2);
  --icon-blue-bg: rgba(59, 130, 246, 0.2);
  --icon-gray-bg: rgba(107, 114, 128, 0.2);
}

/* ============================================
   GLOBAL STYLES
   ============================================ */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: var(--text-primary);
  background-color: var(--background-light);
  margin: 0;
  padding: 0;
}

/* ============================================
   APP CONTAINER
   ============================================ */
.app-container {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  background-color: var(--surface-light);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* ============================================
   MAIN CONTENT
   ============================================ */
.main-content {
  flex: 1;
  padding: 24px 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* ============================================
   FORM SECTIONS (shared primitives)
   ============================================ */
.form-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
}

.form-label .required {
  color: var(--primary);
}

/* ============================================
   SELECT WRAPPER (shared primitive)
   ============================================ */
.select-wrapper {
  position: relative;
}

.select-wrapper select {
  width: 100%;
  padding: 10px 40px 10px 12px;
  background-color: var(--surface-light);
  border: 1px solid var(--border-light);
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: var(--text-primary);
  appearance: none;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.select-wrapper select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(242, 92, 36, 0.1);
}

.select-wrapper select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.select-arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
  font-size: 20px;
}

/* ============================================
   INFO BANNER (shared base — used by MessageBanner
   and inline banners in App.tsx)
   ============================================ */
.info-banner {
  background-color: var(--info-bg);
  border: 1px solid var(--info-border);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
}

.info-banner.fading {
  opacity: 0;
  transform: translateY(-10px);
}

.info-banner.success {
  background-color: var(--success-bg);
  border-color: var(--success-border);
}

.info-banner.success .banner-icon {
  color: var(--success-text);
}

.info-banner.success .banner-text {
  color: var(--success-text);
}

.info-banner.warning {
  background-color: var(--warning-bg);
  border-color: var(--warning-border);
}

.info-banner.warning .banner-icon {
  color: var(--warning-text);
}

.info-banner.warning .banner-text {
  color: var(--warning-text);
}

.info-banner.error {
  background-color: var(--error-bg);
  border-color: var(--error-border);
}

.info-banner.error .banner-icon {
  color: var(--error-text);
}

.info-banner.error .banner-text {
  color: var(--error-text);
}

.banner-icon {
  color: var(--info-icon);
  font-size: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}

.banner-content {
  flex: 1;
}

.banner-text {
  font-size: 12px;
  font-weight: 500;
  color: var(--info-text);
  line-height: 1.4;
}

.banner-close {
  background: none;
  border: none;
  color: var(--info-icon);
  cursor: pointer;
  padding: 0;
  font-size: 18px;
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.banner-close:hover {
  opacity: 1;
}

/* ============================================
   INFO BOX (shared — used by SharePointFolderPicker
   loading state and outgoing-email indicator)
   ============================================ */
.info-box {
  background-color: var(--background-light);
  border: 1px solid var(--border-light);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.info-box-icon {
  color: var(--text-muted);
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 2px;
}

.info-box-text {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.5;
}

/* ============================================
   FOOTER ACTIONS (layout shell)
   ============================================ */
.footer-actions {
  background-color: var(--surface-light);
  border-top: 1px solid var(--border-light);
  padding: 16px 16px 32px 16px;
  position: sticky;
  bottom: 0;
  z-index: 20;
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 400px) {
  .main-content {
    padding: 16px;
    gap: 20px;
  }

  .footer-actions {
    padding: 12px 12px 24px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/App.css"],"names":[],"mappings":"AAAA;;iDAEiD;AACjD;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;;EAEpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;;EAEvB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;;EAEvB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;;EAErB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,kCAAkC;EAClC,sCAAsC;EACtC,oBAAoB;;EAEpB,qCAAqC;EACrC,yCAAyC;EACzC,uBAAuB;;EAEvB,qCAAqC;EACrC,yCAAyC;EACzC,uBAAuB;;EAEvB,kCAAkC;EAClC,sCAAsC;EACtC,qBAAqB;;EAErB,yCAAyC;EACzC,wCAAwC;EACxC,qCAAqC;EACrC,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;;iDAEiD;AACjD;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+EAA+E;EAC/E,0BAA0B;EAC1B,yCAAyC;EACzC,SAAS;EACT,UAAU;AACZ;;AAEA;;iDAEiD;AACjD;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;iDAEiD;AACjD;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;;iDAGiD;AACjD;EACE,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,yCAAyC;EACzC,UAAU;EACV,wBAAwB;EACxB,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,eAAe;EACf,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;;;iDAGiD;AACjD;EACE,yCAAyC;EACzC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE,sCAAsC;EACtC,yCAAyC;EACzC,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;;iDAEiD;AACjD;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* ============================================\n   CSS VARIABLES - Design System\n   ============================================ */\n:root {\n  --primary: #F25C24;\n  --primary-hover: #D94D1A;\n  --secondary: #3E3E3E;\n  --background-light: #F3F4F6;\n  --surface-light: #FFFFFF;\n  --border-light: #E5E7EB;\n  --text-primary: #1F2937;\n  --text-secondary: #6B7280;\n  --text-muted: #9CA3AF;\n\n  /* Info Banner Colors */\n  --info-bg: #EFF6FF;\n  --info-border: #DBEAFE;\n  --info-text: #1E40AF;\n  --info-icon: #3B82F6;\n\n  /* Success Colors */\n  --success-bg: #F0FDF4;\n  --success-border: #BBF7D0;\n  --success-text: #166534;\n\n  /* Warning Colors */\n  --warning-bg: #FEF3C7;\n  --warning-border: #FDE68A;\n  --warning-text: #92400E;\n\n  /* Error Colors */\n  --error-bg: #FEE2E2;\n  --error-border: #FECACA;\n  --error-text: #991B1B;\n\n  /* File Type Colors */\n  --icon-purple: #A855F7;\n  --icon-purple-bg: #F3E8FF;\n  --icon-green: #10B981;\n  --icon-green-bg: #D1FAE5;\n  --icon-red: #EF4444;\n  --icon-red-bg: #FEE2E2;\n  --icon-blue: #3B82F6;\n  --icon-blue-bg: #DBEAFE;\n  --icon-gray: #6B7280;\n  --icon-gray-bg: #F3F4F6;\n}\n\n[data-theme=\"dark\"] {\n  --background-light: #18181b;\n  --surface-light: #27272a;\n  --border-light: #3f3f46;\n  --text-primary: #F3F4F6;\n  --text-secondary: #D1D5DB;\n  --text-muted: #9CA3AF;\n\n  --info-bg: rgba(59, 130, 246, 0.1);\n  --info-border: rgba(59, 130, 246, 0.3);\n  --info-text: #93C5FD;\n\n  --success-bg: rgba(16, 185, 129, 0.1);\n  --success-border: rgba(16, 185, 129, 0.3);\n  --success-text: #6EE7B7;\n\n  --warning-bg: rgba(245, 158, 11, 0.1);\n  --warning-border: rgba(245, 158, 11, 0.3);\n  --warning-text: #FCD34D;\n\n  --error-bg: rgba(239, 68, 68, 0.1);\n  --error-border: rgba(239, 68, 68, 0.3);\n  --error-text: #FCA5A5;\n\n  --icon-purple-bg: rgba(168, 85, 247, 0.2);\n  --icon-green-bg: rgba(16, 185, 129, 0.2);\n  --icon-red-bg: rgba(239, 68, 68, 0.2);\n  --icon-blue-bg: rgba(59, 130, 246, 0.2);\n  --icon-gray-bg: rgba(107, 114, 128, 0.2);\n}\n\n/* ============================================\n   GLOBAL STYLES\n   ============================================ */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: var(--text-primary);\n  background-color: var(--background-light);\n  margin: 0;\n  padding: 0;\n}\n\n/* ============================================\n   APP CONTAINER\n   ============================================ */\n.app-container {\n  width: 100%;\n  max-width: 480px;\n  margin: 0 auto;\n  background-color: var(--surface-light);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n/* ============================================\n   MAIN CONTENT\n   ============================================ */\n.main-content {\n  flex: 1;\n  padding: 24px 20px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* ============================================\n   FORM SECTIONS (shared primitives)\n   ============================================ */\n.form-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-secondary);\n}\n\n.form-label .required {\n  color: var(--primary);\n}\n\n/* ============================================\n   SELECT WRAPPER (shared primitive)\n   ============================================ */\n.select-wrapper {\n  position: relative;\n}\n\n.select-wrapper select {\n  width: 100%;\n  padding: 10px 40px 10px 12px;\n  background-color: var(--surface-light);\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: 'Inter', sans-serif;\n  color: var(--text-primary);\n  appearance: none;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.select-wrapper select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px rgba(242, 92, 36, 0.1);\n}\n\n.select-wrapper select:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.select-arrow {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n  pointer-events: none;\n  font-size: 20px;\n}\n\n/* ============================================\n   INFO BANNER (shared base — used by MessageBanner\n   and inline banners in App.tsx)\n   ============================================ */\n.info-banner {\n  background-color: var(--info-bg);\n  border: 1px solid var(--info-border);\n  border-radius: 8px;\n  padding: 12px;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 0.3s ease-out, transform 0.3s ease-out;\n}\n\n.info-banner.fading {\n  opacity: 0;\n  transform: translateY(-10px);\n}\n\n.info-banner.success {\n  background-color: var(--success-bg);\n  border-color: var(--success-border);\n}\n\n.info-banner.success .banner-icon {\n  color: var(--success-text);\n}\n\n.info-banner.success .banner-text {\n  color: var(--success-text);\n}\n\n.info-banner.warning {\n  background-color: var(--warning-bg);\n  border-color: var(--warning-border);\n}\n\n.info-banner.warning .banner-icon {\n  color: var(--warning-text);\n}\n\n.info-banner.warning .banner-text {\n  color: var(--warning-text);\n}\n\n.info-banner.error {\n  background-color: var(--error-bg);\n  border-color: var(--error-border);\n}\n\n.info-banner.error .banner-icon {\n  color: var(--error-text);\n}\n\n.info-banner.error .banner-text {\n  color: var(--error-text);\n}\n\n.banner-icon {\n  color: var(--info-icon);\n  font-size: 20px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.banner-content {\n  flex: 1;\n}\n\n.banner-text {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--info-text);\n  line-height: 1.4;\n}\n\n.banner-close {\n  background: none;\n  border: none;\n  color: var(--info-icon);\n  cursor: pointer;\n  padding: 0;\n  font-size: 18px;\n  line-height: 1;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.banner-close:hover {\n  opacity: 1;\n}\n\n/* ============================================\n   INFO BOX (shared — used by SharePointFolderPicker\n   loading state and outgoing-email indicator)\n   ============================================ */\n.info-box {\n  background-color: var(--background-light);\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  padding: 12px;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.info-box-icon {\n  color: var(--text-muted);\n  font-size: 16px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.info-box-text {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n/* ============================================\n   FOOTER ACTIONS (layout shell)\n   ============================================ */\n.footer-actions {\n  background-color: var(--surface-light);\n  border-top: 1px solid var(--border-light);\n  padding: 16px 16px 32px 16px;\n  position: sticky;\n  bottom: 0;\n  z-index: 20;\n}\n\n/* ============================================\n   RESPONSIVE\n   ============================================ */\n@media (max-width: 400px) {\n  .main-content {\n    padding: 16px;\n    gap: 20px;\n  }\n\n  .footer-actions {\n    padding: 12px 12px 24px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
